<a [href]="downloadLink.link" target="_blank" style="text-decoration: none;">
  <div class="col-md-12 d-flex annex-card">
    <div class="d-flex flex-column justify-content-center">
      <i class="fas fa-file-pdf fa-2x pdf"></i>
      <span class="badge mt-1" id="size">{{ downloadLink.fileSize }} KB</span>
    </div>
    <div>
      <div class="col-md-12">
        <small class="card-sub align-middle" style="font-weight: 600;">{{ downloadLink.title }}</small>
      </div>
      <div class="col-md-12">
        <small class="time-card text-muted">{{ downloadLink.description }}</small>
      </div>
    </div>
  </div>
</a>